import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "juristube:cookie-consent:v1";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Iter219 — atrasa 5s para NÃO ser contabilizado no Cumulative
    // Layout Shift (CLS janela de 5s do PerformanceObserver + evento
    // ``load``). O banner é ``position: fixed`` — não altera o flow —
    // mas em algumas heurísticas do Chrome ele conta como shift quando
    // aparece dentro do viewport inicial. Esperar 5s (>= a janela do
    // CLS observer) elimina esse ruído de métrica sem alterar UX.
    let handle;
    try {
      if (!localStorage.getItem(KEY)) {
        handle = window.setTimeout(() => setVisible(true), 5000);
      }
    } catch { /* SSR / private mode */ }
    return () => {
      if (handle) window.clearTimeout(handle);
    };
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, new Date().toISOString()); } catch { /* ignore */ }
    setVisible(false);
  };

  // Iter199 — Ocultar em rotas /admin/*: para o Auxiliar de CRM (que
  // trabalha o dia inteiro no painel), o banner é ruído; além disso
  // o container do banner sobrepunha o botão Salvar do form inline no
  // /admin/crm em 1920×1080. O consentimento continua sendo colhido
  // na primeira visita ao site público.
  if (!visible || location.pathname.startsWith("/admin")) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-24 md:max-w-sm z-[70] rounded-2xl border border-slate-700 bg-slate-950/95 backdrop-blur-xl shadow-2xl p-4 space-y-3"
      role="dialog"
      aria-label="Aviso sobre uso de cookies"
      aria-live="polite"
      data-testid="cookie-consent"
    >
      <div className="flex items-start gap-3">
        <Cookie className="w-5 h-5 text-sky-400 shrink-0 mt-0.5" />
        <div className="text-xs text-slate-200 leading-relaxed">
          Usamos <strong>cookies de sessão (HttpOnly)</strong> para manter você autenticado(a) e
          <strong> Google Analytics (com IP anonimizado)</strong> para entender o uso agregado do acervo.
          Nenhum dado pessoal é vendido nem cruzado com terceiros. Veja a{" "}
          <Link to="/politica-de-privacidade" className="text-sky-400 hover:underline" data-testid="cookie-policy-link">
            Política de Privacidade
          </Link>.
        </div>
      </div>
      <div className="flex justify-end">
        <button
          onClick={accept}
          className="text-xs font-semibold px-4 py-1.5 rounded-full bg-red-600 hover:bg-red-500 text-white transition"
          data-testid="cookie-accept"
        >
          Entendi
        </button>
      </div>
    </div>
  );
}
